// @ts-expect-error
import io from 'socket.io-client'
import ioEcg from 'socket.io-client-ecg'
import { ECG_SOCKET_URL, SOCKET_URL } from '../constants/apiConstants'

const URL = SOCKET_URL
export const socket = io(URL, {
  transports: ['websocket'],
  autoConnect: false,
  secure: false,
})

const ECG_URL = ECG_SOCKET_URL
export const ecgSocket = ioEcg(ECG_URL, {
  transports: ['websocket'],
  autoConnect: false,
  secure: false,
})
